'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  min-height: 650px;\n  opacity: 0.5;\n  background-color: #FFF;\n  z-index: 999999;\n  right: 0;\n  left: 0;\n  position: fixed;\n  top: 0 !important;\n\n  & > div {\n    top: 40%;\n    left: 50%;\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n  min-height: 650px;\n  opacity: 0.5;\n  background-color: #FFF;\n  z-index: 999999;\n  right: 0;\n  left: 0;\n  position: fixed;\n  top: 0 !important;\n\n  & > div {\n    top: 40%;\n    left: 50%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _MozartLoading = require('../MozartLoading');

var _MozartLoading2 = _interopRequireDefault(_MozartLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BinaryIframeSpinner = _styledComponents2.default.div(_templateObject);

var MozartIframe = function (_Component) {
  _inherits(MozartIframe, _Component);

  function MozartIframe(props) {
    _classCallCheck(this, MozartIframe);

    // const {id} = this.props;
    var _this = _possibleConstructorReturn(this, (MozartIframe.__proto__ || Object.getPrototypeOf(MozartIframe)).call(this, props));

    _this.state = {
      loading: true
    };
    _this.onLoad = function () {
      _this.removeOnLoadEvent();
      if (_this.props.onLoad) {
        setTimeout(function () {
          _this.props.onLoad();
        }, 2000);
      }
      // if (id && document.getElementById(id)) { document.getElementById(id).src = document.getElementById(id).src; }
      _this.displayIframeInlineBlock();
      _this.setState({
        loading: false
      });
    };
    return _this;
  }

  _createClass(MozartIframe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initialLoad();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.initialLoad();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.src !== nextProps.src || this.props.id !== nextProps.id && this.props.src !== nextProps.src || this.state.loading && !nextState.loading;
    }
  }, {
    key: 'initialLoad',
    value: function initialLoad() {
      var _props = this.props,
          alwaysShow = _props.alwaysShow,
          delayShowTime = _props.delayShowTime,
          refIframeOnload = _props.refIframeOnload;

      if (!alwaysShow) {
        _reactDom2.default.findDOMNode(this.refs.iframe).style.display = 'none';
      }
      if (refIframeOnload) {
        _reactDom2.default.findDOMNode(this.refs.iframe).addEventListener('load', this.onLoad);
        this.displayAfterCertainTime(delayShowTime);
      } else {
        this.setState({
          loading: false
        });
      }
    }
  }, {
    key: 'removeOnLoadEvent',
    value: function removeOnLoadEvent() {
      _reactDom2.default.findDOMNode(this.refs.iframe).removeEventListener('load', this.onLoad);
    }
  }, {
    key: 'displayAfterCertainTime',
    value: function displayAfterCertainTime(millisecond) {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.props.style.display !== 'none' && _reactDom2.default.findDOMNode(_this2.refs.iframe) !== null) {
          _reactDom2.default.findDOMNode(_this2.refs.iframe).style.display = 'inline-block';
        }
      }, millisecond);
    }
  }, {
    key: 'displayIframeInlineBlock',
    value: function displayIframeInlineBlock() {
      if (typeof this.props.style.display === 'undefined') {
        _reactDom2.default.findDOMNode(this.refs.iframe).style.display = 'inline-block';
      } else {
        if (this.props.style.display !== 'none') {
          _reactDom2.default.findDOMNode(this.refs.iframe).style.display = 'inline-block';
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': this.props.themeId },
        this.state.loading && _react2.default.createElement(
          BinaryIframeSpinner,
          null,
          _react2.default.createElement(_MozartLoading2.default, { id: this.props.id + '_spinner', inline: true })
        ),
        _react2.default.createElement('iframe', _extends({ title: this.props.id, style: { minHeight: '600px' }, ref: 'iframe' }, this.props))
      );
    }
  }]);

  return MozartIframe;
}(_react.Component);

MozartIframe.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** id of iframe */
  id: _propTypes2.default.string,
  /** src of iframe */
  src: _propTypes2.default.string.isRequired,
  /** style override */
  style: _propTypes2.default.object,
  /** show iframe if false iframe display none */
  alwaysShow: _propTypes2.default.bool,
  /** delay time to show the iframe */
  delayShowTime: _propTypes2.default.number,
  /** callback when iframe loaded */
  onLoad: _propTypes2.default.func,
  /** */
  refIframeOnload: _propTypes2.default.bool
};
MozartIframe.defaultProps = {
  alwaysShow: true,
  testId: 'MozartIframe',
  themeId: 'MozartIframe',
  delayShowTime: 3000,
  style: {},
  id: Math.random(),
  refIframeOnload: true
};
exports.default = MozartIframe;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartIframe/MozartIframe.js
// module id = 2110
// module chunks = 1